<script lang="ts" setup>
const props = defineProps({
  compact: Boolean,
  isSelected: {
    type: Boolean,
    default: false,
  },
  selectedColor: {
    type: Array as PropType<number[]>,
    default: [0, 0, 0],
  },
  height: {
    type: Number,
    default: 40,
  },
  size: {
    type: Number,
    default: 20,
  },
  showColor: {
    type: Boolean,
    default: true,
  },
  width: {
    type: Number,
    default: 40,
  },
  height: {
    type: Number,
    default: 40,
  },
});

const emit = defineEmits(["selectColor"]);

const allColors = computed(() => {
  return [
    [255, 255, 0], // yellow
    [173, 216, 255], // blue
    [0, 255, 0], // green
    [255, 153, 153], // red
  ];
});

const selectColor = (color?: number[]) => {
  showPicker.value = false;
  emit("selectColor", color);
};

const showPicker = ref(false);

const onHide = () => {
  showPicker.value = false;
};
</script>

<template>
  <span>
    <BasePopover align="start">
      <div
        class="active:bg-opacity-20 flex flex-col items-center justify-center rounded hover:bg-medium-default hover:bg-opacity-10 transition-colors duration-150 cursor-pointer"
        :style="{
          height: `${height}px`,
          width: `${height}px`,
        }"
        :class="{
          'gap-0.5': compact,
          'mx-1 p-1': !compact,
          'bg-primary-default bg-opacity-20 text-primary-default hover:bg-primary-default':
            isSelected,
        }"
        @mousedown.stop.prevent
        @mouseup.stop.prevent="showPicker = true"
      >
        <icon
          name="mdi:format-color-highlight"
          :size="size.toString()"
          :class="{ 'mt-[1.5px]': !compact }"
        />
        <slot name="label" />
        <div
          v-if="showColor"
          class="rounded"
          :class="compact ? 'h-0.5 w-4' : 'h-[3px] w-[80%]'"
          :style="{
            'background-color': useArrayToRGB(selectedColor),
          }"
        >
          &nbsp;
        </div>
      </div>
      <template #content>
        <div class="p-1 pb-3 flex flex-col items-center">
          <BaseTextButton @click="selectColor()" class="py-1 px-1">
            <span class="flex flex-row items-center">
              <icon name="mdi:format-color-marker-cancel" />
              <span class="ml-1 text-[12px]"> Clear Highlight </span>
            </span>
          </BaseTextButton>
          <div class="flex flex-row justify-center gap-1 w-full mt-1">
            <span
              v-for="(color, index) in allColors"
              :key="index"
              class="cursor-pointer hover:opacity-40 aspect-square w-[20px] h-[20px] border rounded"
              :style="{
                'background-color': useArrayToRGB(color),
              }"
              @mousedown.stop.prevent
              @click="selectColor(color)"
            >
              &nbsp;
            </span>
          </div>
        </div>
      </template>
    </BasePopover>
  </span>
</template>

<style scoped></style>
